import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthorizationStrategy } from '../../feature-seatmap';

/**
 * Initialize authentication.
 * OIDC encrypted storage initializes eagerly when AuthService is injected,
 * and checkAuthIncludingServer() awaits it before checking auth state.
 */
export function initializeAuth() {
  const authorizationService = inject(AuthorizationStrategy);
  return firstValueFrom(authorizationService.checkAuthIncludingServer());
}
